
export const solutions = {
  '1gb.solutions': '1Gb Solutions',
  '10gb.solutions': '10Gb Solutions',
  '1gb.vpx.accessories': '1Gb VPX Accessories',
  'software': 'Software',
  '1gb.description': 'High-performance 1Gb AV over IP solutions',
  '10gb.description': 'Ultra-high-performance 10Gb AV over IP solutions',
  'vpx.accessories.description': 'Essential accessories for 1Gb VPX solutions',
  'software.description': 'Aurora\'s IPBaseT Manager software is an all in one control application for the IPX, VPX, and VLX series of Aurora IPBaseT AV over IP products',
  'avoip.solutions': 'AVOIP Solutions',
  'choose.network.speed': 'Choose your preferred network speed',
  'touch.controllers': 'Touch Controllers',
  'touch.controllers.description': 'Professional touch panel interfaces for seamless control',
  'control.processors': 'Control Processors',
  'control.processors.description': 'Advanced control processors for system management',
  'reax.software': 'Software',
  'reax.software.description': 'Professional control system development software',
  'reax.accessories': 'Accessories',
  'reax.accessories.description': 'Essential accessories for ReAX systems',
  'reax.control.solutions': 'ReAX Control Solutions',
  'choose.control.solution': 'Choose your preferred control solution',
  'digital.signal.processors': 'Digital Signal Processors',
  'dsps.description': 'Professional audio processing solutions',
  'amplifiers': 'Amplifiers',
  'amplifiers.description': 'High-performance audio amplification',
  'speakers': 'Speakers',
  'speakers.description': 'Premium audio reproduction solutions',
  'audio.solutions': 'Audio Solutions',
  'choose.audio.solution': 'Choose your preferred audio solution',
};
